import { initDrawers } from "flowbite/lib/esm/components/drawer";
import { initCollapses } from "flowbite/lib/esm/components/collapse";
import { initDropdowns } from "flowbite/lib/esm/components/dropdown";
initDrawers();
initCollapses();
initDropdowns();

import { ReadTimeEstimator } from "./readtimeestimator/readtimeestimator";
import { CustomDrawer } from "./drawer/customdrawer";

import "./headinganimation/headinganimation";
console.log("importing");

declare global {
  interface Window {
    handleNewsFiltersSubmit: (event: Event) => void;
  }
}
document.addEventListener("DOMContentLoaded", function () {
  initDropdowns();
  initDrawers();
  initCollapses();

  new CustomDrawer("language");
  new CustomDrawer("search");
  const estimator = new ReadTimeEstimator();
  estimator.updateReadTimeElements();

  const tables = document.querySelectorAll("table");
  tables.forEach((table) => {
    if (!table.parentElement?.classList.contains("table-container")) {
      const wrapper = document.createElement("div");
      wrapper.classList.add("table-container");

      table.parentNode?.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }
  });

  const anchorLinks = document.querySelectorAll('a[data-anchorlink="true"]');
  anchorLinks.forEach((link) => {
    link.addEventListener("click", (event) => {
      const href = link.getAttribute("href");

      // Only handle internal anchor links (e.g., #section or current URL + #section)
      if (href && href.startsWith("#")) {
        const targetId = href.substring(1);
        const targetElement = document.getElementById(targetId);
        if (targetElement) {
          event.preventDefault();
          targetElement.scrollIntoView({ behavior: "smooth" });
        }
      }
      // Let other hrefs (like "https://example.com") behave normally
    });
  });
});

function handleNewsFilters(event: Event) {
  event.preventDefault();
  event.stopPropagation();
  console.log("PUSH UPDATE");

  const form = document.getElementById("newsfilters") as HTMLFormElement;
  const formData = new FormData(form);
  const params = new URLSearchParams(formData as any).toString();
  history.pushState(null, "", window.location.pathname + "?" + params);
  window.dispatchEvent(new Event("newsFilterChanged"));
}

window.handleNewsFiltersSubmit = handleNewsFilters;

class ImageContainerAdjuster {
  private container: HTMLElement | null;
  private image: HTMLElement | null;
  private resizeObserver: ResizeObserver | null = null;

  constructor(containerSelector: string, imageSelector: string) {
    this.container = document.querySelector(containerSelector);
    this.image = this.container?.querySelector(imageSelector) ?? null;

    if (this.container && this.image) {
      this.init();
    }
  }

  private init(): void {
    window.addEventListener("load", () => this.adjustHeight());
    window.addEventListener("resize", () => this.adjustHeight());

    // Use ResizeObserver to detect size changes dynamically
    this.resizeObserver = new ResizeObserver(() => this.adjustHeight());
    this.resizeObserver.observe(this.image);
  }

  private adjustHeight(): void {
    if (!this.container || !this.image) return;

    const containerRect = this.container.getBoundingClientRect();
    const imageRect = this.image.getBoundingClientRect();

    const offsetTop = imageRect.top - containerRect.top; // Now relative to container start
    const imageHeight = this.image.offsetHeight; // Actual image height
    const requiredHeight = offsetTop + imageHeight;

    this.container.style.minHeight = `${requiredHeight}px`;
  }
}

// Usage
new ImageContainerAdjuster(".herocontainer", ".heroimage");

